import React from 'react';
import CustomSnackbar from '../../../Optics/Components/CustomSnackbar';
import { Snackbar } from '@mui/material';
import { EditingCableLineConstruction } from '../../WriteData/WriteConstructCommunications';

const EditingLineCableConstruct = ({ isEditing, setLinkEditing, setPolylinePoints, lineEditing, lengthCableEditing, 
        lineId, user, setLineId, highwayRefresh, setLineEditing, markerEditing, cantonRefresh, handleEditingCancelClick}) => {

  const { showSnackbar, snackbarOpen, handleCloseSnackbar, snackbarMessage, snackbarClass } = CustomSnackbar();

  const saveEditingLine = async () => {
    
    EditingCableLineConstruction(lineId, lineEditing,lengthCableEditing, markerEditing, user, setLineEditing,
                     setLineId, setLinkEditing, highwayRefresh, showSnackbar, cantonRefresh,
                     setPolylinePoints);
    }  

    if (isEditing) {
    return (
      <div className="divCurrentLengthCable">
         <label style={{ color: '#d1d1d1', fontSize: "16px" }}>Редактирование кабеля</label>
         <hr className='horizontalLineDialog2'/>
        <label style={{ color: '#ebebeb', marginBottom: "5px" }}>Длина кабеля: <span style={{ color: '#fcc205' }}>{lengthCableEditing}  м.</span></label>
        <br/>
        <button  class='buttonEditingLineSave'style={{marginRight: "5px"}} onClick={saveEditingLine} > Сохранить изменения</button>
        <button  class='buttonEditingLineСancel' onClick={handleEditingCancelClick}> Отмена</button>

      {/* Snackbar */}
      <Snackbar
         anchorOrigin={{
         vertical: 'bottom',
         horizontal: 'left',
         }}
         open={snackbarOpen}
         autoHideDuration={3000}
         onClose={handleCloseSnackbar}
         message={snackbarMessage}
         ContentProps={{
          style: {
            color: snackbarClass === 'snackbarOk' ? '#ffda62' : '#202020'
          }         
        }}
      />       
      </div>
    );
    
  } else {
    return null;
  }  
}

export default EditingLineCableConstruct;